export const getFilterQueryParam = (filter = {}, include?: string[], limit=100) => {
    return {
        filter: JSON.stringify({
            where: filter,
            include,
            limit,
        })
    }
}